import React from 'react';
import './TermsConditions.css';
import SEOHead from '../SEOHead';

const TermsConditions: React.FC = () => {
  // Immediate scroll to top on component render
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="terms-conditions">
      <SEOHead
        title="Terms & Conditions of Service"
        description="Read Antaryatra's Terms and Conditions governing the use of our puja booking platform, payments, cancellations and service delivery."
        canonicalPath="/terms-conditions"
        noIndex={false}
      />
      <div className="container">
        <div className="legal-content">
          <h1>Terms & Conditions of Service</h1>
          <div className="last-updated">
            Last updated: January 10, 2026
          </div>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Antaryatra's services, you accept and agree to be bound by the 
              terms and provision of this agreement. These Terms of Service govern your use of our 
              platform and services.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Antaryatra is a platform that connects users with service providers for spiritual and 
              religious services. We facilitate bookings, payments, and communications between users 
              and service providers.
            </p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>To use certain features of our service, you must:</p>
            <ul>
              <li>Create an account with accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Be responsible for all activities under your account</li>
              <li>Notify us immediately of any unauthorized use</li>
              <li>Be at least 18 years old or have parental consent</li>
            </ul>
          </section>

          <section>
            <h2>4. Service Booking and Payment</h2>
            <p>When you book services through our platform:</p>
            <ul>
              <li>You agree to pay the specified fees for the services</li>
              <li>Payment is processed through secure third-party processors</li>
              <li>Service availability and pricing may vary by location</li>
              <li>You may be required to provide additional information for service delivery</li>
              <li>Booking confirmation does not guarantee service completion</li>
            </ul>
          </section>

          <section>
            <h2>5. Service Provider Relationship</h2>
            <p>
              Service providers on our platform are independent contractors. Antaryatra acts as an 
              intermediary and is not responsible for:
            </p>
            <ul>
              <li>The quality, safety, or legality of services provided</li>
              <li>The truth or accuracy of service provider listings</li>
              <li>The ability of service providers to deliver services</li>
              <li>Any disputes between users and service providers</li>
            </ul>
          </section>

          <section>
            <h2>6. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any unlawful purpose</li>
              <li>Harass, abuse, or harm other users or service providers</li>
              <li>Post false, misleading, or fraudulent information</li>
              <li>Interfere with the operation of our platform</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use automated systems to access our services</li>
            </ul>
          </section>

          <section>
            <h2>7. Cancellation and Refunds</h2>
            <p>
              Cancellation and refund policies vary by service type and timing. Please refer to our 
              Refund Policy for detailed information about cancellations, refunds, and related procedures.
            </p>
          </section>

          <section>
            <h2>8. Intellectual Property</h2>
            <p>
              All content, features, and functionality of our platform are owned by Antaryatra and 
              are protected by copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2>9. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. Our collection and use of personal information is 
              governed by our Privacy Policy, which is incorporated into these terms by reference.
            </p>
          </section>

          <section>
            <h2>10. Disclaimers and Limitation of Liability</h2>
            <p>
              Our services are provided "as is" without warranties of any kind. We are not liable for:
            </p>
            <ul>
              <li>Indirect, incidental, or consequential damages</li>
              <li>Loss of profits, data, or business opportunities</li>
              <li>Service interruptions or technical issues</li>
              <li>Actions or omissions of service providers</li>
            </ul>
          </section>

          <section>
            <h2>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold Antaryatra harmless from any claims, damages, or 
              expenses arising from your use of our services or violation of these terms.
            </p>
          </section>

          <section>
            <h2>12. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account at any time for violations 
              of these terms or for any other reason at our sole discretion.
            </p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>
              We may modify these terms at any time. Significant changes will be communicated to 
              users. Continued use of our services constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2>14. Governing Law</h2>
            <p>
              These terms are governed by the laws of India. Any disputes shall be resolved in 
              the courts of [Your Jurisdiction].
            </p>
          </section>

          <section>
            <h2>15. Contact Information</h2>
            <p>
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> communication@antaryatra.org</p>
              {/* <p><strong>Phone:</strong> +91 XXXXX XXXXX</p> */}
              <p><strong>Address:</strong> N6/2B-124, Indira Nagar, Chitaipur, Varanasi, Uttar Pradesh - 221005, India</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;